import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Baseurl } from "../../config/BaseUrl";

const getCachedData = (key) => {
  try {
    if (typeof window !== "undefined") {
      const local = localStorage.getItem(key);
      if (local) return JSON.parse(local);
      const session = sessionStorage.getItem(key);
      if (session) return JSON.parse(session);
    }
    return [];
  } catch (e) {
    return [];
  }
};

const initialState = {
  subCatTotal: getCachedData("cached_subCatTotal"),
  isLoading: false,
  subcatLoading: false,
};

export const getSubCategory = createAsyncThunk(
  "SubCategory/getSubCategory",
  async (thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/subcategory/all`;
      const resp = await axios(url);
      return resp.data.subcategory;
    } catch (error) {
      return thunkAPI.rejectWithValue("subcategory Not Found");
    }
  }
);
  
const SubCategorySlice = createSlice({
  name: "SubCategory",
  initialState,
  extraReducers: {
    [getSubCategory.pending]: (state) => {
      state.isLoading = true;
    },
    [getSubCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.subcatLoading = false;
      state.subCatTotal = action.payload || [];
      try {
        if (typeof window !== "undefined") {
          localStorage.setItem("cached_subCatTotal", JSON.stringify(action.payload));
          sessionStorage.setItem("cached_subCatTotal", JSON.stringify(action.payload));
        }
      } catch (e) {}
    },
    [getSubCategory.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export default SubCategorySlice.reducer;
